import React, { useState, useEffect, useRef } from "react";

import CajasService from "../services/cajas.service";
import EventBus from "../common/EventBus";
import {
  Container,
  ListGroup,
  Row,
  Col,
  Button,
  Modal,
  Tab,
  Tabs,
} from "react-bootstrap/";
import MUIDataTable from "mui-datatables";
import { toast } from "react-toastify";
import EmpleadosService from "../services/empleados.service";
import PagosCuentasCorrientesService from "../services/pagos_cuentas_corrientes.service";
import PCCService from "../services/pagos_cuentas_corrientes.service";
import { useNavigate } from "react-router-dom";
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Typography from "@mui/material/Typography";
import "./styleTabs.css";
import { PDFDownloadLink } from "@react-pdf/renderer";
import ResumenDeCajaCerrada from "./reports/ResumenDeCajaCerrada";
import ReactDOM from "react-dom";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

import Lottie from "react-lottie";

import * as lapiz from "../assets/reloj.json";

const dayjs = require("dayjs");
const ExcelJS = require('exceljs');

const Cobros = () => {
  const [content, setContent] = useState("");
  const [responseCode, setResponseCode] = useState("");

  const containerRef = useRef(null);
  const navigate = useNavigate();

  // Modal
  const [fullscreen, setFullscreen] = useState(true);
  const [show, setShow] = useState(false);
  const [search, setSearch] = useState("");
  const [tituloModal, setTituloModal] = useState("");
  const [modo, setModo] = useState("");
  // Fin Modal

  // Modal Pregunta//
  const [tituloModalPregunta, setTituloModalPregunta] = useState("Atención");
  const [fullscreenPregunta, setFullscreenPregunta] = useState(true);
  const [showPregunta, setShowPregunta] = useState(false);
  // Fin Modal Pregunta//

  // Modal InformeCaja//
  const [tituloModalInformeCaja, setTituloModalInformeCaja] =
    useState("Informe de Caja");
  const [fullscreenInformeCaja, setFullscreenInformeCaja] = useState(true);
  const [showInformeCaja, setShowInformeCaja] = useState(false);
  // Fin Modal InformeCaja//

  const [empleados, setEmpleados] = useState([]);
  const [dataElegido, setDataElegido] = useState([]);
  const [cajaActual, setCajaActual] = useState([]);
  const [historialDeCajas, setHistorialDeCajas] = useState([]);
  const [informeCaja, setInformeCaja] = useState([]);
  const [historialPagosCaja, setHistorialPagosCaja] = useState([]);

  const [loadingData, setLoadingData] = useState(false);

  // Modal Comprobante Pago CC//
  const [showComprobantePagoCC, setShowComprobantePagoCC] = useState(false);
  const [tituloModalComprobantePagoCC, setTituloModalComprobantePagoCC] =
    useState("");
  const [dataGetPago, setDataGetPago] = useState(false);
  // Fin Modal Comprobante Pago CC//

  // Modal Editar Pago//
  const [showEditarPago, setShowEditarPago] = useState(false);
  const [tituloModalEditarPago, setTituloModalEditarPago] = useState("");
  const [dataEditarPago, setDataEditarPago] = useState({});
  // Fin Modal Editar Pago//

  // Opciones Select Cuentas Destino//
  const optionsSelectCuentasDestino = [
    { value: "Transferencia", text: "Transferencia 💸" },
    { value: "Cheque", text: "Cheque 🎫" },
    { value: "Efectivo", text: "Efectivo 💵" },
    { value: "Tarjeta", text: "Tarjeta 💳" },
  ];
  // Fin Opciones Select //

  const [loadingExcel, setLoadingExcel] = useState(undefined);
  const [dataCajaCerrada, setDataCajaCerrada] = useState([]);

  const lapízOptions = {
    loop: true,
    autoplay: true,
    animationData: lapiz.default,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  useEffect(() => {
    setLoadingData(true);
    EmpleadosService.getAllEmpleados().then(
      (response) => {
        setEmpleados(response.data);
        setResponseCode(response.status);
        setLoadingData(false);
      },
      (error) => {
        const _content =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      setContent(_content);
      setLoadingData(false);
      if (error.response && error.response.status === 401) {
        EventBus.dispatch("logout");
      }
      }
    );
    /*
    UsuariosService.getAllUsers().then(
      (response) => {
        setEmpleados(response.data.empleados);
        setResponseCode(response.status);
        setLoadingData(false);
      },
      (error) => {
        const _content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        setContent(_content);
        setLoadingData(false);
        if (error.response && error.response.status === 401) {
          EventBus.dispatch("logout");
        }
      }
    );
    */
  }, []);

  const columnsEmpleados = [
    {
      name: "DNI",
      label: "DNI",
      options: {
        display: "excluded",
      },
    },
    {
      name: "Nombre",
      label: "Nombre",
    },
    {
      name: "CodigoVendedor",
      label: "Codigo de Vendedor",
    },
  ];

  const columnsHistorialDeCajas = [
    {
      name: "idCaja",
      label: "ID",
      options: {
        display: "excluded",
      },
    },
    {
      name: "FechaCierre",
      label: "Fecha de Cierre",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Row style={{ paddingLeft: 30 }}>
              {dayjs(value).format("DD/MM/YYYY HH:mm")}
            </Row>
          );
        },
      },
    },
    {
      name: "Total",
      label: "Total",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          const nf = new Intl.NumberFormat("es-AR", {
            style: "decimal",
            currency: "ARS",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
          return nf.format(value);
        },
      },
    },
    {
      name: "ChequeMonto",
      label: "ChequeMonto",
      options: {
        display: "excluded",
        customBodyRender: (value, tableMeta, updateValue) => {
          const nf = new Intl.NumberFormat("es-AR", {
            style: "decimal",
            currency: "ARS",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
          return nf.format(value);
        },
      },
    },
    {
      name: "TarjetaMonto",
      label: "TarjetaMonto",
      options: {
        display: "excluded",
        customBodyRender: (value, tableMeta, updateValue) => {
          const nf = new Intl.NumberFormat("es-AR", {
            style: "decimal",
            currency: "ARS",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
          return nf.format(value);
        },
      },
    },
    {
      name: "TransferenciaMonto",
      label: "TransferenciaMonto",
      options: {
        display: "excluded",
        customBodyRender: (value, tableMeta, updateValue) => {
          const nf = new Intl.NumberFormat("es-AR", {
            style: "decimal",
            currency: "ARS",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
          return nf.format(value);
        },
      },
    },
    {
      name: "EfectivoMonto",
      label: "EfectivoMonto",
      options: {
        display: "excluded",
        customBodyRender: (value, tableMeta, updateValue) => {
          const nf = new Intl.NumberFormat("es-AR", {
            style: "decimal",
            currency: "ARS",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
          return nf.format(value);
        },
      },
    },
    {
      name: "Observaciones",
      label: "Observaciones",
      options: {
        display: "excluded",
      },
    },
    {
      name: "Total", // Lo traigo de nuevo para que se guarde sin el formato y poder mostrarlo después
      label: "Total",
      options: {
        display: "excluded",
        customBodyRender: (value, tableMeta, updateValue) => {
          const nf = new Intl.NumberFormat("es-AR", {
            style: "decimal",
            currency: "ARS",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
          return nf.format(value);
        },
      },
    },
    {
      name: "FechaCierre", // Lo traigo de nuevo para que se guarde sin el formato y poder mostrarlo después
      label: "Fecha de Cierre",
      options: {
        display: "excluded",
        customBodyRender: (value, tableMeta, updateValue) => {
          return dayjs(value).format("DD/MM/YYYY HH:mm");
        },
      },
    },
  ];

  const columnsPagosCajaActual = [
    {
      name: "idPago",
      label: "ID",
      options: {
        display: "excluded",
      },
    },
    {
      name: "cuentas_corriente.cliente.RazonSocial",
      label: "Razón Social",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return <Row style={{ paddingLeft: 30 }}>{value}</Row>;
        },
      },
    },
    {
      name: "Tipo",
      label: "Tipo",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return <Row style={{ paddingLeft: 30 }}>{value}</Row>;
        },
      },
    },
    {
      name: "Total",
      label: "Total",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          const nf = new Intl.NumberFormat("es-AR", {
            style: "decimal",
            currency: "ARS",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
          return (
            <Row style={{ paddingLeft: 30 }}>{"$" + nf.format(value)}</Row>
          );
        },
      },
    },
  ];

  const columnsPagosHistorialCaja = [
    {
      name: "idPago",
      label: "ID",
      options: {
        display: "excluded",
      },
    },
    {
      name: "cliente",
      label: "Razón Social",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return <Row style={{ paddingLeft: 30 }}>{value}</Row>;
        },
      },
    },
    {
      name: "tipo",
      label: "Tipo",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return <Row style={{ paddingLeft: 30 }}>{value}</Row>;
        },
      },
    },
    {
      name: "total",
      label: "Total",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          const nf = new Intl.NumberFormat("es-AR", {
            style: "decimal",
            currency: "ARS",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
          return (
            <Row style={{ paddingLeft: 30 }}>{"$" + nf.format(value)}</Row>
          );
        },
      },
    },
  ];

  const options = {
    filterType: "checkbox",
    onRowsDelete: () => {
      return false;
    },
    rowsPerPageOptions: 30,
    rowsPerPage: 30,
    selectToolbarPlacement: "replace",
    responsive: "standard",
    searchOpen: true,
    searchAlwaysOpen: true,
    searchPlaceholder: "Buscar Empleado",
    filter: false,
    expandableRows: false,
    expandableRowsHeader: false,
    expandableRowsOnClick: false,
    download: false,
    print: false,
    fixedHeader: true,
    fixedSelectColumn: true,
    enableNestedDataAccess: ".",
    onSearchClose: () => {
      console.log("Cierra");
    },
    isRowExpandable: (dataIndex, expandedRows) => {
      /*
          if(expandedRows.data.length>1){
            let original = expandedRows.data;
            let aux = expandedRows.data.slice(dataIndex,-1);
            expandedRows.data = aux;
            setMostradas(aux);
            return true;
          }
          else{

          }
          //expandedRows.data=[]; // Esto hace que siempre haya uno solo expandido
          return true;
          */
      //if (dataIndex === 3 || dataIndex === 4) return false;

      // Prevent expand/collapse of any row if there are 4 rows expanded already (but allow those already expanded to be collapsed)
      if (
        expandedRows.data.length > 8 &&
        expandedRows.data.filter((d) => d.dataIndex === dataIndex).length === 0
      )
        return false;
      return true;
    },
    isRowSelectable: () => {
      return false;
    },
    selectableRows: false,
    rowsExpanded: [],
    onRowClick: async (rowData) => {
      console.log(rowData);
      setDataElegido(rowData);
      cargarModalEmpleado(rowData);
    },
    /*
        renderExpandableRow: (rowData, rowMeta) => {
          if(!isTabletOrMobile){
            const colSpan = rowData.length + 1;
            return (
              <TableRow>
                <TableCell colSpan={colSpan} >
                  <Card>{rowData}</Card>
                </TableCell>
              </TableRow>
            );
          }
        },
        */
    renderExpandableRow: (rowData, rowMeta) => {},
    onRowExpansionChange: (curExpanded, allExpanded, rowsExpanded) => {
      console.log(curExpanded, allExpanded, rowsExpanded);
    },
  };

  const optionsHistorialDeCajas = {
    filterType: "checkbox",
    onRowsDelete: () => {
      return false;
    },
    rowsPerPageOptions: 100,
    selectToolbarPlacement: "replace",
    responsive: "standard",
    searchOpen: true,
    searchAlwaysOpen: true,
    searchPlaceholder: "Buscar Caja",
    filter: false,
    expandableRows: false,
    expandableRowsHeader: false,
    expandableRowsOnClick: false,
    download: false,
    print: false,
    fixedHeader: true,
    fixedSelectColumn: true,
    enableNestedDataAccess: ".",
    onSearchClose: () => {
      console.log("Cierra");
    },
    isRowExpandable: (dataIndex, expandedRows) => {
      /*
          if(expandedRows.data.length>1){
            let original = expandedRows.data;
            let aux = expandedRows.data.slice(dataIndex,-1);
            expandedRows.data = aux;
            setMostradas(aux);
            return true;
          }
          else{

          }
          //expandedRows.data=[]; // Esto hace que siempre haya uno solo expandido
          return true;
          */
      //if (dataIndex === 3 || dataIndex === 4) return false;

      // Prevent expand/collapse of any row if there are 4 rows expanded already (but allow those already expanded to be collapsed)
      if (
        expandedRows.data.length > 8 &&
        expandedRows.data.filter((d) => d.dataIndex === dataIndex).length === 0
      )
        return false;
      return true;
    },
    isRowSelectable: () => {
      return false;
    },
    selectableRows: false,
    rowsExpanded: [],
    onRowClick: async (rowData) => {
      console.log(rowData);
      setInformeCaja(rowData);
      setLoadingData(true);
      CajasService.getHistorialPagosCaja(rowData[0]).then((response) => {
        console.log(response);
        setDataCajaCerrada(response.data);
        let aux = [];
        response.data.pagos.forEach(pago => {
          let auxPago = {
            cliente: pago.cuentas_corriente.cliente.RazonSocial,
            tipo: pago.Tipo == "Transferencia" ? "Pago - " + pago.Tipo + " - " + pago.TransferenciaCuentaDestino : "Pago - " + pago.Tipo,
            total: parseFloat(pago.Total),
            observaciones: pago.ObservacionesDescuento != null ? pago.ObservacionesDescuento :
                        pago.ObservacionesNDD != null ? pago.ObservacionesNDD :
                        pago.Observaciones,
          };
          aux.push(auxPago);
        });
        response.data.pps.forEach(pp => {
          let auxPP = {
            cliente: pp.cliente.RazonSocial,
            tipo: "Pp",
            total: parseFloat(pp.importe),
            observaciones: "N° de Pp: " + pp.idPp,
          };
          aux.push(auxPP);
        });
        response.data.facturas.forEach(factura => {
          let auxFactura = {
            cliente: factura.cliente.RazonSocial,
            tipo: "Factura",
            total: parseFloat(factura.Importe),
            observaciones: "N° de Factura: " + factura.idFactura,
          };
          aux.push(auxFactura);
        });
        setHistorialPagosCaja(aux);
        setLoadingData(false);
        setShowInformeCaja(true);
      });
    },
    /*
        renderExpandableRow: (rowData, rowMeta) => {
          if(!isTabletOrMobile){
            const colSpan = rowData.length + 1;
            return (
              <TableRow>
                <TableCell colSpan={colSpan} >
                  <Card>{rowData}</Card>
                </TableCell>
              </TableRow>
            );
          }
        },
        */
    renderExpandableRow: (rowData, rowMeta) => {},
    onRowExpansionChange: (curExpanded, allExpanded, rowsExpanded) => {
      console.log(curExpanded, allExpanded, rowsExpanded);
    },
  };

  const optionsPagosCajaActual = {
    filterType: "checkbox",
    onRowsDelete: () => {
      return false;
    },
    rowsPerPageOptions: 100,
    selectToolbarPlacement: "replace",
    responsive: "standard",
    searchOpen: true,
    searchAlwaysOpen: true,
    searchPlaceholder: "Buscar pago",
    filter: false,
    expandableRows: false,
    expandableRowsHeader: false,
    expandableRowsOnClick: false,
    download: false,
    print: false,
    fixedHeader: true,
    fixedSelectColumn: true,
    enableNestedDataAccess: ".",
    elevation: 0,
    onSearchClose: () => {
      console.log("Cierra");
    },
    isRowExpandable: (dataIndex, expandedRows) => {
      /*
          if(expandedRows.data.length>1){
            let original = expandedRows.data;
            let aux = expandedRows.data.slice(dataIndex,-1);
            expandedRows.data = aux;
            setMostradas(aux);
            return true;
          }
          else{

          }
          //expandedRows.data=[]; // Esto hace que siempre haya uno solo expandido
          return true;
          */
      //if (dataIndex === 3 || dataIndex === 4) return false;

      // Prevent expand/collapse of any row if there are 4 rows expanded already (but allow those already expanded to be collapsed)
      if (
        expandedRows.data.length > 8 &&
        expandedRows.data.filter((d) => d.dataIndex === dataIndex).length === 0
      )
        return false;
      return true;
    },
    isRowSelectable: () => {
      return false;
    },
    selectableRows: false,
    rowsExpanded: [],
    onRowClick: async (rowData) => {
      console.log(rowData);
      cargarModalPago(rowData);
    },
    /*
        renderExpandableRow: (rowData, rowMeta) => {
          if(!isTabletOrMobile){
            const colSpan = rowData.length + 1;
            return (
              <TableRow>
                <TableCell colSpan={colSpan} >
                  <Card>{rowData}</Card>
                </TableCell>
              </TableRow>
            );
          }
        },
        */
    renderExpandableRow: (rowData, rowMeta) => {},
    onRowExpansionChange: (curExpanded, allExpanded, rowsExpanded) => {
      console.log(curExpanded, allExpanded, rowsExpanded);
    },
  };

  const cargarModalPago = (rowData) => {
    setLoadingData(true);
    PagosCuentasCorrientesService.getPago(rowData[0]).then(
      (response) => {
        console.log(response.data);
        let auxDataGetPago = response.data;
        const nf = new Intl.NumberFormat("es-AR", {
          style: "decimal",
          currency: "ARS",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
        auxDataGetPago.ChequeMonto = nf.format(auxDataGetPago.ChequeMonto);
        auxDataGetPago.EfectivoMonto = nf.format(
          auxDataGetPago.EfectivoMonto
        );
        auxDataGetPago.TarjetaMonto = nf.format(auxDataGetPago.TarjetaMonto);
        auxDataGetPago.TransferenciaMonto = nf.format(
          auxDataGetPago.TransferenciaMonto
        );
        auxDataGetPago.Total = nf.format(auxDataGetPago.Total);
        setDataGetPago(auxDataGetPago);
        setLoadingData(false);
        setTituloModalComprobantePagoCC(response.data.idPago);
        setShowComprobantePagoCC(true);
        //response.data.map((articulo) => console.log(articulo));
        //setLoadingData(true);
      },
      (error) => {
        const _content =
          (error.response && error.response.data) ||
          error.message ||
          error.toString();
        setLoadingData(false);
        //setContent(_content);
        //setLoadingData(true);

        if (error.response && error.response.status === 401) {
          EventBus.dispatch("logout");
        }
      }
    );
  };
  const cargarModalEmpleado = async (rowData) => {
    setLoadingData(true);
      const responseCaja = await CajasService.searchCaja(rowData[2]);
      let auxCajaActual = responseCaja.data;
      const nf = new Intl.NumberFormat("es-AR", {
        style: "decimal",
        currency: "ARS",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      auxCajaActual.montos.montoCheque = nf.format(
        auxCajaActual.montos.montoCheque
      );
      auxCajaActual.montos.montoEfectivo = nf.format(
        auxCajaActual.montos.montoEfectivo
      );
      auxCajaActual.montos.montoTarjeta = nf.format(
        auxCajaActual.montos.montoTarjeta
      );
      auxCajaActual.montos.montoTransferencia = nf.format(
        auxCajaActual.montos.montoTransferencia
      );
      auxCajaActual.montos.montoTotal = nf.format(
        auxCajaActual.montos.montoTotal
      );
      setCajaActual(auxCajaActual);
      const responseHistorial = await CajasService.getHistorialCajas(
        rowData[2]
      );
      setLoadingData(false);
      setHistorialDeCajas(responseHistorial.data);
      setShow(true);
  };

  const cerrarModal = () => {
    setShow(false);
  };

  const cerrarModalPregunta = () => {
    setShowPregunta(false);
  };

  const cerrarModalInformeCaja = () => {
    setShowInformeCaja(false);
  };

  const cerrarModalCierraCaja = () => {
    if (parseFloat(cajaActual.pagos.length) === 0) {
      toast.error(<div>No se puede cerrar una caja sin movimientos</div>, {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        whiteSpace: "pre-line",
      });
      setShowPregunta(false);
      return;
    }
    let observacion = document.getElementById("observacion").value;
    setLoadingData(true);
    CajasService.cerrarCaja(dataElegido[2], observacion).then(
      async (response) => {
        console.log(response);
        toast.success(<div>Caja cerrada correctamente</div>, {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          whiteSpace: "pre-line",
        });
        const responseCaja = await CajasService.searchCaja(dataElegido[2]);
        setCajaActual(responseCaja.data);
        const responseHistorial = await CajasService.getHistorialCajas(
          dataElegido[2]
        );
        setLoadingData(false);
        setHistorialDeCajas(responseHistorial.data);
        setShowPregunta(false);
      },
      (error) => {
        const _content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        setLoadingData(false);
        toast.error(
          <div>
            {error.message}. De persistir el error contáctese con soporte
          </div>,
          {
            position: "top-center",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            whiteSpace: "pre-line",
          }
        );
        setContent(_content);

        if (error.response && error.response.status === 401) {
          EventBus.dispatch("logout");
        }
      }
    );
  };
  const chequesClicked = () => {
    navigate("/admin/cheques");
  };

  const historicoCajasClicked = () => {
    navigate("/admin/historicocajas");
  };

  function handleShowComprobantePagoCC(breakpoint) {
    setShowComprobantePagoCC(true);
  }
  function handleShowCerrarGetComprobantePagoCC() {
    setShowComprobantePagoCC(false);
  }

  // Función para formatear números en tiempo real con formato argentino
  const formatArgentineNumber = (value) => {
    if (!value) return '';

    // Remover todo excepto dígitos, coma y puntos
    let cleaned = value.toString().replace(/[^\d,\.]/g, '');

    // Si hay múltiples comas, mantener solo la primera
    let commaIndex = cleaned.indexOf(',');
    if (commaIndex !== -1) {
      let beforeComma = cleaned.substring(0, commaIndex);
      let afterComma = cleaned.substring(commaIndex + 1);
      // Remover puntos y comas adicionales después de la primera coma
      afterComma = afterComma.replace(/[,\.]/g, '');
      cleaned = beforeComma + ',' + afterComma;
    }

    // Separar parte entera y decimal
    let parts = cleaned.split(',');
    let integerPart = parts[0].replace(/\./g, ''); // Remover puntos existentes
    let decimalPart = parts[1];

    // Formatear parte entera con puntos como separadores de miles
    if (integerPart.length > 3) {
      integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }

    // Si hay parte decimal
    if (decimalPart !== undefined) {
      // Limitar decimales a 2 dígitos
      decimalPart = decimalPart.substring(0, 2);
      return `${integerPart},${decimalPart}`;
    }

    // Si el valor termina con coma, mantenerla
    if (cleaned.endsWith(',')) {
      return `${integerPart},`;
    }

    return integerPart;
  };

  // Función para convertir formato argentino a número
  const parseArgentineNumber = (value) => {
    if (!value) return 0;
    if (typeof value === 'number') return value;

    // Remover puntos de miles y reemplazar coma decimal por punto
    let cleaned = value.toString().replace(/\./g, '').replace(',', '.');
    return parseFloat(cleaned) || 0;
  };

  // Función para manejar cambios en campos de monto
  const handleMontoChange = (field, value) => {
    const formatted = formatArgentineNumber(value);
    setDataEditarPago({...dataEditarPago, [field]: formatted});
  };

  // Función para manejar monto de descuento
  const handleMontoDescuentoChange = (value) => {
    const formatted = formatArgentineNumber(value);
    setDataEditarPago({...dataEditarPago, Total: formatted});
  };

  const abrirModalEditarPago = () => {
    // Crear una copia de los datos completos del pago
    let dataParaEditar = {...dataGetPago};

    // Formatear los montos para mostrar en formato argentino
    if (dataParaEditar.ChequeMonto) {
      const value = parseArgentineNumber(dataParaEditar.ChequeMonto);
      dataParaEditar.ChequeMonto = formatArgentineNumber(value.toFixed(2).replace('.', ','));
    }
    if (dataParaEditar.EfectivoMonto) {
      const value = parseArgentineNumber(dataParaEditar.EfectivoMonto);
      dataParaEditar.EfectivoMonto = formatArgentineNumber(value.toFixed(2).replace('.', ','));
    }
    if (dataParaEditar.TarjetaMonto) {
      const value = parseArgentineNumber(dataParaEditar.TarjetaMonto);
      dataParaEditar.TarjetaMonto = formatArgentineNumber(value.toFixed(2).replace('.', ','));
    }
    if (dataParaEditar.TransferenciaMonto) {
      const value = parseArgentineNumber(dataParaEditar.TransferenciaMonto);
      dataParaEditar.TransferenciaMonto = formatArgentineNumber(value.toFixed(2).replace('.', ','));
    }
    if (dataParaEditar.Total) {
      const value = parseArgentineNumber(dataParaEditar.Total);
      dataParaEditar.Total = formatArgentineNumber(value.toFixed(2).replace('.', ','));
    }

    // Asegurar que todos los campos específicos del tipo de pago estén disponibles
    switch(dataParaEditar.Tipo) {
      case "Cheque":
        // Los campos de cheque ya deberían estar presentes en dataGetPago
        // ChequeFechaPago, ChequeBancoEmisor, ChequeFechaVencimiento, ChequeNroCheque, ChequeDigital
        break;
      case "Efectivo":
        // Los campos de efectivo ya deberían estar presentes
        // EfectivoFechaPago
        break;
      case "Tarjeta":
        // Los campos de tarjeta ya deberían estar presentes
        // TarjetaFechaPago, TarjetaNroComprobante, TipoDeTarjeta
        break;
      case "Transferencia":
        // Los campos de transferencia ya deberían estar presentes
        // TransferenciaFechaPago, TransferenciaCuentaDestino, TransferenciaNroComprobante
        break;
      case "Descuento":
        // Los campos de descuento ya deberían estar presentes
        // ObservacionesDescuento
        break;
      case "Nota De Débito":
        // Los campos de nota de débito ya deberían estar presentes
        // ObservacionesNDD
        break;
    }

    setDataEditarPago(dataParaEditar);
    setTituloModalEditarPago(`Editar Pago N° ${dataGetPago.idPago}`);
    setShowEditarPago(true);
  };

  const cerrarModalEditarPago = () => {
    setShowEditarPago(false);
    setDataEditarPago({});
  };

  const guardarCambiosPago = () => {
    setLoadingData(true);

    let pagoEditado = {...dataEditarPago};

    // Convertir formatos argentinos a números para el envío
    pagoEditado.ChequeMonto = parseArgentineNumber(pagoEditado.ChequeMonto);
    pagoEditado.EfectivoMonto = parseArgentineNumber(pagoEditado.EfectivoMonto);
    pagoEditado.TarjetaMonto = parseArgentineNumber(pagoEditado.TarjetaMonto);
    pagoEditado.TransferenciaMonto = parseArgentineNumber(pagoEditado.TransferenciaMonto);
    pagoEditado.Total = parseArgentineNumber(pagoEditado.Total);

    switch(pagoEditado.Tipo) {
      case "Cheque":
        pagoEditado.Total = pagoEditado.ChequeMonto;
        break;
      case "Efectivo":
        pagoEditado.Total = pagoEditado.EfectivoMonto;
        break;
      case "Tarjeta":
        pagoEditado.Total = pagoEditado.TarjetaMonto;
        break;
      case "Transferencia":
        pagoEditado.Total = pagoEditado.TransferenciaMonto;
        break;
    }

    PCCService.editarPago(pagoEditado.idPago, pagoEditado).then(response => {
      console.log(response);
      if(response.status === 200){
        toast.success("Pago editado correctamente");
        setShowEditarPago(false);
        setShowComprobantePagoCC(false);
        setShow(false);
        cargarModalEmpleado(dataElegido);
      }
      else{
        toast.error("Error al editar el pago");
      }
      setLoadingData(false);
    }).catch(error => {
      console.log(error);
      toast.error("Error al editar el pago: " + (error.response?.data?.message || error.message));
      setLoadingData(false);
    });
  };

  const exportarExcel = async () => {
    console.log("Exportar a Excel");
    let user = JSON.parse(localStorage.getItem("user"));
    setLoadingExcel(true);
    try {
      // Importar ExcelJS dinámicamente
      const ExcelJS = await import('exceljs');

      // Crear un nuevo libro de trabajo
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Datos', {
        pageSetup: {
          orientation: 'landscape',
          fitToPage: true,
          fitToWidth: 1,
          fitToHeight: 0,
          paperSize: 9 // A4
        }
      });

      // Definir las columnas
      worksheet.columns = [
        { header: 'Fecha', key: 'fecha', width: 15 },
        { header: 'N° Cliente', key: 'numCliente', width: 15 },
        { header: 'Cliente', key: 'cliente', width: 30 },
        { header: 'Tipo', key: 'tipo', width: 35 },
        { header: 'Total', key: 'total', width: 15 },
        { header: 'Observaciones', key: 'observaciones', width: 40 },
        { header: 'Creado Por', key: 'usuario', width: 20 },
        { header: 'Eliminado', key: 'eliminado', width: 20 }
      ];

      // Crear un array para todos los elementos
      let todosLosElementos = [];

      // Agregar facturas al array
      dataCajaCerrada.facturas.forEach(factura => {
          todosLosElementos.push({
            fecha: dayjs(factura.FechaCarga).toDate(),
            numCliente: factura.cliente.idCliente,
            cliente: factura.cliente.RazonSocial,
            tipo: "Factura",
            total: parseFloat(factura.Importe),
            observaciones: "N° de Factura: " + factura.idFactura,
            usuario: factura.Empleado || '',
            eliminado: factura.deletedAt != null ? "Si" : "No"
          });
      });

      // Agregar PPs al array
      dataCajaCerrada.pps.forEach(pp => {
          todosLosElementos.push({
            fecha: dayjs(pp.fecha).toDate(),
            numCliente: pp.cliente.idCliente,
            cliente: pp.cliente.RazonSocial,
            tipo: "Pp",
            total: parseFloat(pp.importe),
            observaciones: "N° de Pp: " + pp.idPp,
            usuario: pp.user?.empleado?.CodigoVendedor || '',
            eliminado: pp.deletedAt != null ? "Si" : "No"
          });
      });

      // Agregar pagos al array
      dataCajaCerrada.pagos.forEach(pago => {
        todosLosElementos.push({
          fecha: dayjs(pago.Fecha).toDate(),
          numCliente: pago.cuentas_corriente.cliente.idCliente,
          cliente: pago.cuentas_corriente.cliente.RazonSocial,
          tipo: pago.Tipo == "Transferencia" ? "Pago - " + pago.Tipo + " - " + pago.TransferenciaCuentaDestino : "Pago - " + pago.Tipo,
          total: parseFloat(pago.Total),
          observaciones: pago.ObservacionesDescuento != null ? pago.ObservacionesDescuento :
                        pago.ObservacionesNDD != null ? pago.ObservacionesNDD :
                        pago.Observaciones,
          usuario: pago.user?.empleado?.CodigoVendedor || '',
          eliminado: pago.deletedAt != null ? "Si" : "No"
        });
      });

      // Ordenar todos los elementos por fecha
      todosLosElementos.sort((a, b) => a.fecha - b.fecha);

      // Agregar los elementos ordenados a la hoja
      todosLosElementos.forEach(elemento => {
        worksheet.addRow({
          fecha: dayjs(elemento.fecha).format("DD/MM/YYYY"),
          numCliente: elemento.numCliente,
          cliente: elemento.cliente,
          tipo: elemento.tipo,
          total: elemento.total,
          observaciones: elemento.observaciones,
          usuario: elemento.usuario,
          eliminado: elemento.eliminado
        });
      });

      // Aplicar color rojo a todas las celdas de la fila si está eliminado
      worksheet.eachRow((row) => {
        if(row.getCell('eliminado').value === "Si") {
          row.eachCell((cell) => {
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FFFF0000' }
            };
          });
        }
      });

      // Agregar filas adicionales
      worksheet.addRow({});
      worksheet.addRow({
        cliente: "Empleado: " + dataCajaCerrada.cajaBuscada.empleado.Nombre + " " + dataCajaCerrada.cajaBuscada.empleado.Apellido,
        tipo: "Fecha: " + dayjs(dataCajaCerrada.cajaBuscada.FechaCierre).format("DD/MM/YYYY HH:mm:ss")
      });

      worksheet.addRow({});
      worksheet.addRow({cliente: "Monto Pagos"});
      worksheet.addRow({
        tipo: "Monto Efectivo",
        total: dataCajaCerrada.montos.montoEfectivo
      });
      worksheet.addRow({
        tipo: "Monto Transferencias",
        total: dataCajaCerrada.montos.montoTransferencia
      });
      worksheet.addRow({
        tipo: "Monto Cheques",
        total: dataCajaCerrada.montos.montoCheque
      });
      worksheet.addRow({
        tipo: "Monto Tarjetas",
        total: dataCajaCerrada.montos.montoTarjeta
      });
      worksheet.addRow({
        tipo: "Monto Notas de Débito",
        total: dataCajaCerrada.montos.montoDebito
      });
      worksheet.addRow({
        tipo: "Monto Descuento",
        total: dataCajaCerrada.montos.montoDescuento
      });
      let montoSinDescuentos = dataCajaCerrada.montos.montoEfectivo + dataCajaCerrada.montos.montoTransferencia + dataCajaCerrada.montos.montoCheque + dataCajaCerrada.montos.montoTarjeta + dataCajaCerrada.montos.montoDebito;
      worksheet.addRow({});
      worksheet.addRow({tipo: "Porcentaje Comisión %", total: user.empleado.porcentaje_comision});
      worksheet.addRow({});
      worksheet.addRow({
        tipo: "Monto Total Con Descuentos",
        total: dataCajaCerrada.montos.montoTotal
      });
      worksheet.addRow({
        tipo: "Monto Total Sin Descuentos",
        total: montoSinDescuentos
      });
      worksheet.addRow({
        tipo: "Monto Comisión",
        total: montoSinDescuentos * user.empleado.porcentaje_comision / 100
      });
      // Dar formato a las celdas de Total
      worksheet.getColumn('total').numFmt = '#,##0.00';

      // Generar el archivo
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      FileSaver.saveAs(
        blob,
        "Caja Abierta " + dayjs().format("DD/MM/YYYY H:m:ss") + ".xlsx"
      );

      setLoadingExcel(false);
    } catch (error) {
      console.log(error);
      setLoadingExcel(false);
      toast.error(
        <div>Error al exportar a Excel. Por favor, inténtelo de nuevo.</div>,
        {
          position: "top-center",
          autoClose: 2000
        }
      );
    }
  };

  const exportarPDF = () => {
    console.log("Exportar a PDF");
    // Aquí puedes continuar con el proceso de descarga utilizando los pagos filtrados
    // Descargar resumen de cuenta
    // Crear un elemento PDFDownloadLink temporal
    const pdfLink = (
      <PDFDownloadLink
        document={
          <ResumenDeCajaCerrada
            idCaja={informeCaja[0]}
            fechaDeCierre={informeCaja[1]}
            montoEfectivo={informeCaja[6]}
            montoTransferencias={informeCaja[5]}
            montoCheques={informeCaja[3]}
            montoTarjetas={informeCaja[4]}
            montoTotal={informeCaja[8]}
            observacionCaja={informeCaja[7]}
            nombreEmpleado={dataElegido[1]}
            telefonoEmpleado={informeCaja[13]}
            pagos={historialPagosCaja}
          />
        }
        fileName={`Resumen de Caja N° ${informeCaja[0]} ${dayjs().format(
          "DD/MM/YYYY"
        )}.pdf`}
      />
    );

    // Renderizar el elemento temporal
    // Importar ReactDOM si no está importado al principio del archivo
    // Crear una función para manejar la descarga del PDF

    // Eliminar cualquier elemento temporal anterior
    const elementosTemporales = document.querySelectorAll(".pdf-temporal");
    elementosTemporales.forEach((elemento) => elemento.remove());

    // Crear un único elemento temporal para el PDF
    const contenedorTemporal = document.createElement("div");
    contenedorTemporal.className = "pdf-temporal";
    contenedorTemporal.style.display = "none";
    document.body.appendChild(contenedorTemporal);

    // Esperar a que el PDF se genere
    setTimeout(() => {
      const enlaceDescarga = contenedorTemporal.querySelector("a");
      if (enlaceDescarga) {
        enlaceDescarga.click();
        // Eliminar el elemento temporal después de la descarga
        setTimeout(() => contenedorTemporal.remove(), 1000);
      } else {
        console.error("No se pudo encontrar el enlace de descarga");
        toast.error(
          "Hubo un problema al generar el PDF. Por favor, inténtelo de nuevo."
        );
      }
    }, 1000);

    // Renderizar el PDF en el elemento temporal
    ReactDOM.render(pdfLink, contenedorTemporal);
    // Mostrar mensaje de éxito
    toast.success(
      <div>El resumen de cuenta se ha descargado correctamente</div>,
      {
        position: "top-center",
      }
    );
  };

  const exportarExcelCajaAbierta = async () => {
    console.log("Exportar a Excel");
    setLoadingExcel(true);

    try {
      const responseInformeCajaAbierta = await CajasService.getInformeCajaAbierta(dataElegido[2]);
      console.log(responseInformeCajaAbierta);

      let user = JSON.parse(localStorage.getItem("user"));
      console.log(user);
      let empleado_porcentaje_comision = user.empleado.porcentaje_comision;
      console.log(empleado_porcentaje_comision); 
      // Importar ExcelJS dinámicamente
      const ExcelJS = await import('exceljs');

      // Crear un nuevo libro de trabajo
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Datos', {
        pageSetup: {
          orientation: 'landscape',
          fitToPage: true,
          fitToWidth: 1,
          fitToHeight: 0,
          paperSize: 9 // A4
        },
      });

      // Definir las columnas
      worksheet.columns = [
        { header: 'Fecha', key: 'fecha', width: 12 },
        { header: 'N° Cliente', key: 'numCliente', width: 15 },
        { header: 'Cliente', key: 'cliente', width: 30 },
        { header: 'Tipo', key: 'tipo', width: 35 },
        { header: 'Total', key: 'total', width: 15 },
        { header: 'Observaciones', key: 'observaciones', width: 40 },
        { header: 'Creado (Cod. Vend)', key: 'usuario', width: 20 },
        { header: 'Eliminado', key: 'eliminado', width: 20 }
      ];

      // Aplicar estilo a los encabezados
      const headerRow = worksheet.getRow(1);
      headerRow.font = { size: 16, bold: true };
      headerRow.height = 28;

      // Crear un array para todos los elementos
      let todosLosElementos = [];

      // Agregar facturas al array
      responseInformeCajaAbierta.data.clientes.forEach(cliente => {
        cliente.facturas.forEach(factura => {
          todosLosElementos.push({
            fecha: dayjs(factura.FechaCarga).toDate(),
            numCliente: factura.cliente.idCliente,
            cliente: factura.cliente.RazonSocial,
            tipo: "Factura",
            total: parseFloat(factura.Importe),
            observaciones: "N° de Factura: " + factura.idFactura,
            usuario: factura.Empleado || '',
            eliminado: factura.deletedAt != null ? "Si" : "No"
          });
        });
      });

      // Agregar PPs al array
      responseInformeCajaAbierta.data.clientes.forEach(cliente => {
        cliente.pps.forEach(pp => {
          todosLosElementos.push({
            fecha: dayjs(pp.fecha).toDate(),
            numCliente: pp.cliente.idCliente,
            cliente: pp.cliente.RazonSocial,
            tipo: "Pp",
            total: parseFloat(pp.importe),
            observaciones: "N° de Pp: " + pp.idPp,
            usuario: pp.user?.empleado?.CodigoVendedor || '',
            eliminado: pp.deletedAt != null ? "Si" : "No"
          });
        });
      });

      // Agregar pagos al array
      responseInformeCajaAbierta.data.pagos.forEach(pago => {
        // traer acá en la consulta el user dentro del pago para sacar la data del empleado
        todosLosElementos.push({
          fecha: dayjs(pago.Fecha).toDate(),
          numCliente: pago.cuentas_corriente.cliente.idCliente,
          cliente: pago.cuentas_corriente.cliente.RazonSocial,
          tipo: pago.Tipo == "Transferencia" ? "Pago - " + pago.Tipo + " - " + pago.TransferenciaCuentaDestino : "Pago - " + pago.Tipo,
          total: parseFloat(pago.Total),
          observaciones: pago.ObservacionesDescuento != null ? pago.ObservacionesDescuento :
                        pago.ObservacionesNDD != null ? pago.ObservacionesNDD :
                        pago.Observaciones,
          usuario: pago.user?.empleado?.CodigoVendedor || '',
          eliminado: pago.deletedAt != null ? "Si" : "No"
        });
      });

      // Ordenar todos los elementos por fecha
      todosLosElementos.sort((a, b) => a.fecha - b.fecha);

      // Agregar los elementos ordenados a la hoja
      todosLosElementos.forEach(elemento => {
        worksheet.addRow({
          fecha: dayjs(elemento.fecha).format("DD/MM/YYYY"),
          numCliente: elemento.numCliente,
          cliente: elemento.cliente,
          tipo: elemento.tipo,
          total: elemento.total,
          observaciones: elemento.observaciones,
          usuario: elemento.usuario,
          eliminado: elemento.eliminado
        });
      });

      // Aplicar estilo de fuente a todas las filas de datos
      worksheet.eachRow((row, rowNumber) => {
        if (rowNumber > 1) { // Saltar la fila de encabezados
          row.font = { size: 14 };
          row.height = 25;
        }
      });

      // Aplicar color rojo a todas las celdas de la fila si está eliminado
      worksheet.eachRow((row) => {
        if(row.getCell('eliminado').value === "Si") {
          row.eachCell((cell) => {
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FFFF0000' }
            };
            cell.font = { size: 14, color: { argb: 'FFFFFFFF' } }; // Texto blanco para mejor contraste
          });
        }
      });

      // Agregar filas adicionales
      const currentRowCount = worksheet.rowCount;
      worksheet.addRow({});

      const infoRow1 = worksheet.addRow({
        cliente: "Empleado: " + dataElegido[1],
        tipo: "Fecha: Caja Abierta"
      });
      infoRow1.font = { size: 15, bold: true };
      infoRow1.height = 27;

      worksheet.addRow({});

      const montosHeaderRow = worksheet.addRow({cliente: "Monto Pagos"});
      montosHeaderRow.font = { size: 15, bold: true };
      montosHeaderRow.height = 27;

      const  montoTotalSinDescuentos = parseFloat(responseInformeCajaAbierta.data.montos.montoCheque) + parseFloat(responseInformeCajaAbierta.data.montos.montoEfectivo) + parseFloat(responseInformeCajaAbierta.data.montos.montoTarjeta) + parseFloat(responseInformeCajaAbierta.data.montos.montoTransferencia) + parseFloat(responseInformeCajaAbierta.data.montos.montoDebito);

      const montoComision = montoTotalSinDescuentos * empleado_porcentaje_comision / 100;

      const montoRows = [
        {
          tipo: "Monto Efectivo",
          total: responseInformeCajaAbierta.data.montos.montoEfectivo
        },
        {
          tipo: "Monto Transferencias",
          total: responseInformeCajaAbierta.data.montos.montoTransferencia
        },
        {
          tipo: "Monto Cheques",
          total: responseInformeCajaAbierta.data.montos.montoCheque
        },
        {
          tipo: "Monto Tarjetas",
          total: responseInformeCajaAbierta.data.montos.montoTarjeta
        },
        {
          tipo: "Monto Notas de Débito",
          total: responseInformeCajaAbierta.data.montos.montoDebito
        },
        {
          tipo: "Monto Descuento",
          total: responseInformeCajaAbierta.data.montos.montoDescuento
        },
        {
          tipo: "Monto Total Sin Descuentos",
          total: montoTotalSinDescuentos
        },
        {
          tipo: "Porcentaje Comisión %",
          total: empleado_porcentaje_comision
        }
      ];

      montoRows.forEach(montoData => {
        const row = worksheet.addRow(montoData);
        row.font = { size: 14 };
        row.height = 25;
      });

      const totalRow = worksheet.addRow({
        tipo: "Monto Total Con Descuentos",
        total: responseInformeCajaAbierta.data.montos.montoTotal
      });
      totalRow.font = { size: 15, bold: true };
      totalRow.height = 27;

      const montoComisionRow = worksheet.addRow({
        tipo: "Monto Comisión",
        total: montoComision
      });
      montoComisionRow.font = { size: 15, bold: true };
      montoComisionRow.height = 27;
      // Dar formato a las celdas de Total
      worksheet.getColumn('total').numFmt = '#,##0.00';

      // Generar el archivo
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      FileSaver.saveAs(
        blob,
        "Caja Abierta " + dayjs().format("DD/MM/YYYY H:m:ss") + ".xlsx"
      );

      setLoadingExcel(false);
    } catch (error) {
      console.log(error);
      setLoadingExcel(false);
      toast.error(
        <div>Error al exportar a Excel. Por favor, inténtelo de nuevo.</div>,
        {
          position: "top-center",
          autoClose: 2000
        }
      );
    }
  };

  const eliminarPago = () => {
    console.log("Eliminar pago");
    PCCService.eliminarPago(dataGetPago.idPago).then(response => {
      console.log(response);
      if(response.status === 200){
        toast.success("Pago eliminado correctamente");
        setShowComprobantePagoCC(false);
        setShow(false);
        cargarModalEmpleado(dataElegido);
      }
      else{
        toast.error("Error al eliminar el pago");
      }
    }).catch(error => {
      console.log(error);
      toast.error("Error al eliminar el pago: " + error.response.data.message);
    });
  };

  if (responseCode === 200) {
    return (
      <Container flex>
        {loadingData ? (
          <Lottie options={lapízOptions} height={200} width={200} />
        ) : (
          <div>
            <Modal
              show={showComprobantePagoCC}
              fullscreen={true}
              onHide={() => handleShowComprobantePagoCC()}
            >
              <Modal.Header>
                <Modal.Title>
                  Comprobante: {tituloModalComprobantePagoCC}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Row className="d-flex justify-content-center">
                  <Col>
                    {dataGetPago.Tipo === "Cheque" ? (
                      <div>
                        <ul>
                          <li>
                            Fecha:{" "}
                            <b>
                              {dayjs(dataGetPago.Fecha).format(
                                "DD/MM/YY HH:mm:ss"
                              )}
                            </b>
                          </li>
                          <li>
                            Cheque Fecha Pago:{" "}
                            <b>
                              {dayjs(dataGetPago.ChequeFechaPago).format(
                                "DD/MM/YY"
                              )}
                            </b>
                          </li>
                          <li>
                            Cheque Banco Emisor:{" "}
                            <b>{dataGetPago.ChequeBancoEmisor}</b>
                          </li>
                          <li>
                            Cheque Fecha Vencimiento:{" "}
                            <b>
                              {dayjs(dataGetPago.ChequeFechaVencimiento).format(
                                "DD/MM/YY"
                              )}
                            </b>
                          </li>
                          <li>
                            Número de Cheque:{" "}
                            <b>{dataGetPago.ChequeNroCheque}</b>
                          </li>
                          <li>
                            Cheque Monto: <b>$ {dataGetPago.ChequeMonto}</b>
                          </li>
                          <li>
                            Cheque Digital:{" "}
                            <b>{dataGetPago.ChequeDigital ? "Si" : "No"}</b>
                          </li>
                          <li>
                            Observaciones: <b>{dataGetPago.Observaciones}</b>
                          </li>
                        </ul>
                      </div>
                    ) : dataGetPago.Tipo === "Efectivo" ? (
                      <div>
                        <ul>
                          <li>
                            Fecha:{" "}
                            <b>
                              {dayjs(dataGetPago.Fecha).format(
                                "DD/MM/YY HH:mm:ss"
                              )}
                            </b>
                          </li>
                          <li>
                            Efectivo Fecha Pago:{" "}
                            <b>
                              {dayjs(dataGetPago.EfectivoFechaPago).format(
                                "DD/MM/YY"
                              )}
                            </b>
                          </li>
                          <li>
                            Efectivo Monto: <b>$ {dataGetPago.EfectivoMonto}</b>
                          </li>
                          <li>
                            Observaciones: <b>{dataGetPago.Observaciones}</b>
                          </li>
                        </ul>
                      </div>
                    ) : dataGetPago.Tipo === "Tarjeta" ? (
                      <div>
                        <ul>
                          <li>
                            Fecha:{" "}
                            <b>
                              {dayjs(dataGetPago.Fecha).format(
                                "DD/MM/YY HH:mm:ss"
                              )}
                            </b>
                          </li>
                          <li>
                            Tarjeta Fecha Pago:{" "}
                            <b>
                              {dayjs(dataGetPago.TarjetaFechaPago).format(
                                "DD/MM/YY"
                              )}
                            </b>
                          </li>
                          <li>
                            Tarjeta Nro Comprobante:{" "}
                            <b>{dataGetPago.TarjetaNroComprobante}</b>
                          </li>
                          <li>
                            Tarjeta Monto: <b>$ {dataGetPago.TarjetaMonto}</b>
                          </li>
                          <li>
                            Tipo de Tarjeta: <b>{dataGetPago.TipoDeTarjeta}</b>
                          </li>
                          <li>
                            Observaciones: <b>{dataGetPago.Observaciones}</b>
                          </li>
                        </ul>
                      </div>
                    ) : dataGetPago.Tipo === "Transferencia" ? (
                      <div>
                        <ul>
                          <li>
                            Fecha:{" "}
                            <b>
                              {dayjs(dataGetPago.Fecha).format(
                                "DD/MM/YY HH:mm:ss"
                              )}
                            </b>
                          </li>
                          <li>
                            Transferencia Fecha Pago:{" "}
                            <b>
                              {dayjs(dataGetPago.TransferenciaFechaPago).format(
                                "DD/MM/YY"
                              )}
                            </b>
                          </li>
                          <li>
                            Transferencia Cuenta Destino:{" "}
                            <b>{dataGetPago.TransferenciaCuentaDestino}</b>
                          </li>
                          <li>
                            Transferencia Nro Comprobante:{" "}
                            <b>{dataGetPago.TransferenciaNroComprobante}</b>
                          </li>
                          <li>
                            Transferencia Monto:{" "}
                            <b>$ {dataGetPago.TransferenciaMonto}</b>
                          </li>
                          <li>
                            Observaciones: <b>{dataGetPago.Observaciones}</b>
                          </li>
                        </ul>
                      </div>
                    ) : dataGetPago.Tipo === "Descuento" ? (
                      <div>
                        <ul>
                          <li>
                            Fecha:{" "}
                            <b>
                              {dayjs(dataGetPago.Fecha).format(
                                "DD/MM/YY HH:mm:ss"
                              )}
                            </b>
                          </li>
                          <li>
                            Descuento Monto: <b>$ {dataGetPago.Total}</b>
                          </li>
                          <li>
                            Observaciones Descuento:{" "}
                            <b>{dataGetPago.ObservacionesDescuento}</b>
                          </li>
                        </ul>
                      </div>
                    ) : dataGetPago.Tipo === "Nota De Débito" ? (
                      <div>
                        <ul>
                          <li>
                            Fecha:{" "}
                            <b>
                              {dayjs(dataGetPago.Fecha).format(
                                "DD/MM/YY HH:mm:ss"
                              )}
                            </b>
                          </li>
                          <li>
                            Nota De Débito Monto: <b>$ {dataGetPago.Total}</b>
                          </li>
                          <li>
                            Observaciones Nota de débito:{" "}
                            <b>{dataGetPago.ObservacionesNDD}</b>
                          </li>
                        </ul>
                      </div>
                    ) : null}
                  </Col>
                </Row>
                <Row className="d-flex justify-content-center">
                  <Button variant="outline-danger" onClick={() => eliminarPago()}>
                      Eliminar
                  </Button>
                  <Button variant="warning" style={{marginLeft: 10}} onClick={() => abrirModalEditarPago()}>
                      Editar
                  </Button>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="outline-danger"
                  onClick={() => handleShowCerrarGetComprobantePagoCC()}
                >
                  Salir
                </Button>
              </Modal.Footer>
            </Modal>
            <Modal
              show={showEditarPago}
              fullscreen={true}
              onHide={() => cerrarModalEditarPago()}
            >
              <Modal.Header>
                <Modal.Title>
                  {tituloModalEditarPago}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Row className="d-flex justify-content-center">
                  <Col xs={12} md={8}>
                    {dataEditarPago.Tipo === "Cheque" ? (
                      <div>
                        <h5>Editar Pago - Cheque</h5>
                        <div className="mb-3">
                          <label>Fecha:</label>
                          <input
                            type="datetime-local"
                            className="form-control"
                            value={dataEditarPago.Fecha ? dayjs(dataEditarPago.Fecha).format("YYYY-MM-DDTHH:mm") : ""}
                            onChange={(e) => setDataEditarPago({...dataEditarPago, Fecha: e.target.value})}
                          />
                        </div>
                        <div className="mb-3">
                          <label>Fecha de Pago del Cheque:</label>
                          <input
                            type="date"
                            className="form-control"
                            value={dataEditarPago.ChequeFechaPago ? dayjs(dataEditarPago.ChequeFechaPago).format("YYYY-MM-DD") : ""}
                            onChange={(e) => setDataEditarPago({...dataEditarPago, ChequeFechaPago: e.target.value})}
                          />
                        </div>
                        <div className="mb-3">
                          <label>Banco Emisor:</label>
                          <input
                            type="text"
                            className="form-control"
                            value={dataEditarPago.ChequeBancoEmisor || ""}
                            onChange={(e) => setDataEditarPago({...dataEditarPago, ChequeBancoEmisor: e.target.value})}
                          />
                        </div>
                        <div className="mb-3">
                          <label>Fecha de Vencimiento:</label>
                          <input
                            type="date"
                            className="form-control"
                            value={dataEditarPago.ChequeFechaVencimiento ? dayjs(dataEditarPago.ChequeFechaVencimiento).format("YYYY-MM-DD") : ""}
                            onChange={(e) => setDataEditarPago({...dataEditarPago, ChequeFechaVencimiento: e.target.value})}
                          />
                        </div>
                        <div className="mb-3">
                          <label>Número de Cheque:</label>
                          <input
                            type="text"
                            className="form-control"
                            value={dataEditarPago.ChequeNroCheque || ""}
                            onChange={(e) => setDataEditarPago({...dataEditarPago, ChequeNroCheque: e.target.value})}
                          />
                        </div>
                        <div className="mb-3">
                          <label>Monto del Cheque:</label>
                          <input
                            type="text"
                            className="form-control"
                            value={dataEditarPago.ChequeMonto || ""}
                            onChange={(e) => handleMontoChange('ChequeMonto', e.target.value)}
                            placeholder="0,00"
                          />
                        </div>
                        <div className="mb-3 form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            checked={dataEditarPago.ChequeDigital || false}
                            onChange={(e) => setDataEditarPago({...dataEditarPago, ChequeDigital: e.target.checked})}
                          />
                          <label className="form-check-label">Cheque Digital</label>
                        </div>
                        <div className="mb-3">
                          <label>Observaciones:</label>
                          <textarea
                            className="form-control"
                            rows="3"
                            value={dataEditarPago.Observaciones || ""}
                            onChange={(e) => setDataEditarPago({...dataEditarPago, Observaciones: e.target.value})}
                          />
                        </div>
                      </div>
                    ) : dataEditarPago.Tipo === "Efectivo" ? (
                      <div>
                        <h5>Editar Pago - Efectivo</h5>
                        <div className="mb-3">
                          <label>Fecha:</label>
                          <input
                            type="datetime-local"
                            className="form-control"
                            value={dataEditarPago.Fecha ? dayjs(dataEditarPago.Fecha).format("YYYY-MM-DDTHH:mm") : ""}
                            onChange={(e) => setDataEditarPago({...dataEditarPago, Fecha: e.target.value})}
                          />
                        </div>
                        <div className="mb-3">
                          <label>Fecha de Pago en Efectivo:</label>
                          <input
                            type="date"
                            className="form-control"
                            value={dataEditarPago.EfectivoFechaPago ? dayjs(dataEditarPago.EfectivoFechaPago).format("YYYY-MM-DD") : ""}
                            onChange={(e) => setDataEditarPago({...dataEditarPago, EfectivoFechaPago: e.target.value})}
                          />
                        </div>
                        <div className="mb-3">
                          <label>Monto en Efectivo:</label>
                          <input
                            type="text"
                            className="form-control"
                            value={dataEditarPago.EfectivoMonto || ""}
                            onChange={(e) => handleMontoChange('EfectivoMonto', e.target.value)}
                            placeholder="0,00"
                          />
                        </div>
                        <div className="mb-3">
                          <label>Observaciones:</label>
                          <textarea
                            className="form-control"
                            rows="3"
                            value={dataEditarPago.Observaciones || ""}
                            onChange={(e) => setDataEditarPago({...dataEditarPago, Observaciones: e.target.value})}
                          />
                        </div>
                      </div>
                    ) : dataEditarPago.Tipo === "Tarjeta" ? (
                      <div>
                        <h5>Editar Pago - Tarjeta</h5>
                        <div className="mb-3">
                          <label>Fecha:</label>
                          <input
                            type="datetime-local"
                            className="form-control"
                            value={dataEditarPago.Fecha ? dayjs(dataEditarPago.Fecha).format("YYYY-MM-DDTHH:mm") : ""}
                            onChange={(e) => setDataEditarPago({...dataEditarPago, Fecha: e.target.value})}
                          />
                        </div>
                        <div className="mb-3">
                          <label>Fecha de Pago con Tarjeta:</label>
                          <input
                            type="date"
                            className="form-control"
                            value={dataEditarPago.TarjetaFechaPago ? dayjs(dataEditarPago.TarjetaFechaPago).format("YYYY-MM-DD") : ""}
                            onChange={(e) => setDataEditarPago({...dataEditarPago, TarjetaFechaPago: e.target.value})}
                          />
                        </div>
                        <div className="mb-3">
                          <label>Número de Comprobante:</label>
                          <input
                            type="text"
                            className="form-control"
                            value={dataEditarPago.TarjetaNroComprobante || ""}
                            onChange={(e) => setDataEditarPago({...dataEditarPago, TarjetaNroComprobante: e.target.value})}
                          />
                        </div>
                        <div className="mb-3">
                          <label>Monto de Tarjeta:</label>
                          <input
                            type="text"
                            className="form-control"
                            value={dataEditarPago.TarjetaMonto || ""}
                            onChange={(e) => handleMontoChange('TarjetaMonto', e.target.value)}
                            placeholder="0,00"
                          />
                        </div>
                        <div className="mb-3">
                          <label>Tipo de Tarjeta:</label>
                          <select
                            className="form-select"
                            value={dataEditarPago.TipoDeTarjeta || ""}
                            onChange={(e) => setDataEditarPago({...dataEditarPago, TipoDeTarjeta: e.target.value})}
                          >
                            <option value="">Seleccionar tipo</option>
                            <option value="DÉBITO">DÉBITO</option>
                            <option value="CRÉDITO">CRÉDITO</option>
                          </select>
                        </div>
                        <div className="mb-3">
                          <label>Observaciones:</label>
                          <textarea
                            className="form-control"
                            rows="3"
                            value={dataEditarPago.Observaciones || ""}
                            onChange={(e) => setDataEditarPago({...dataEditarPago, Observaciones: e.target.value})}
                          />
                        </div>
                      </div>
                    ) : dataEditarPago.Tipo === "Transferencia" ? (
                      <div>
                        <h5>Editar Pago - Transferencia</h5>
                        <div className="mb-3">
                          <label>Fecha:</label>
                          <input
                            type="datetime-local"
                            className="form-control"
                            value={dataEditarPago.Fecha ? dayjs(dataEditarPago.Fecha).format("YYYY-MM-DDTHH:mm") : ""}
                            onChange={(e) => setDataEditarPago({...dataEditarPago, Fecha: e.target.value})}
                          />
                        </div>
                        <div className="mb-3">
                          <label>Fecha de Transferencia:</label>
                          <input
                            type="date"
                            className="form-control"
                            value={dataEditarPago.TransferenciaFechaPago ? dayjs(dataEditarPago.TransferenciaFechaPago).format("YYYY-MM-DD") : ""}
                            onChange={(e) => setDataEditarPago({...dataEditarPago, TransferenciaFechaPago: e.target.value})}
                          />
                        </div>
                        <div className="mb-3">
                          <label>Cuenta Destino:</label>
                          <select
                            className="form-select"
                            value={dataEditarPago.TransferenciaCuentaDestino || ""}
                            onChange={(e) => setDataEditarPago({...dataEditarPago, TransferenciaCuentaDestino: e.target.value})}
                          >
                            <option value="">Seleccionar cuenta destino</option>
                            {optionsSelectCuentasDestino.map((option) => (
                              <option key={option.value} value={option.value}>
                                {option.text}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="mb-3">
                          <label>Número de Comprobante:</label>
                          <input
                            type="text"
                            className="form-control"
                            value={dataEditarPago.TransferenciaNroComprobante || ""}
                            onChange={(e) => setDataEditarPago({...dataEditarPago, TransferenciaNroComprobante: e.target.value})}
                          />
                        </div>
                        <div className="mb-3">
                          <label>Monto de Transferencia:</label>
                          <input
                            type="text"
                            className="form-control"
                            value={dataEditarPago.TransferenciaMonto || ""}
                            onChange={(e) => handleMontoChange('TransferenciaMonto', e.target.value)}
                            placeholder="0,00"
                          />
                        </div>
                        <div className="mb-3">
                          <label>Observaciones:</label>
                          <textarea
                            className="form-control"
                            rows="3"
                            value={dataEditarPago.Observaciones || ""}
                            onChange={(e) => setDataEditarPago({...dataEditarPago, Observaciones: e.target.value})}
                          />
                        </div>
                      </div>
                    ) : dataEditarPago.Tipo === "Descuento" ? (
                      <div>
                        <h5>Editar Pago - Descuento</h5>
                        <div className="mb-3">
                          <label>Fecha:</label>
                          <input
                            type="datetime-local"
                            className="form-control"
                            value={dataEditarPago.Fecha ? dayjs(dataEditarPago.Fecha).format("YYYY-MM-DDTHH:mm") : ""}
                            onChange={(e) => setDataEditarPago({...dataEditarPago, Fecha: e.target.value})}
                          />
                        </div>
                        <div className="mb-3">
                          <label>Monto del Descuento:</label>
                          <input
                            type="text"
                            className="form-control"
                            value={dataEditarPago.Total || ""}
                            onChange={(e) => handleMontoDescuentoChange(e.target.value)}
                            placeholder="0,00"
                          />
                        </div>
                        <div className="mb-3">
                          <label>Observaciones del Descuento:</label>
                          <textarea
                            className="form-control"
                            rows="3"
                            value={dataEditarPago.ObservacionesDescuento || ""}
                            onChange={(e) => setDataEditarPago({...dataEditarPago, ObservacionesDescuento: e.target.value})}
                          />
                        </div>
                      </div>
                    ) : dataEditarPago.Tipo === "Nota De Débito" ? (
                      <div>
                        <h5>Editar Pago - Nota de Débito</h5>
                        <div className="mb-3">
                          <label>Fecha:</label>
                          <input
                            type="datetime-local"
                            className="form-control"
                            value={dataEditarPago.Fecha ? dayjs(dataEditarPago.Fecha).format("YYYY-MM-DDTHH:mm") : ""}
                            onChange={(e) => setDataEditarPago({...dataEditarPago, Fecha: e.target.value})}
                          />
                        </div>
                        <div className="mb-3">
                          <label>Monto de la Nota de Débito:</label>
                          <input
                            type="text"
                            className="form-control"
                            value={dataEditarPago.Total || ""}
                            onChange={(e) => handleMontoChange('Total', e.target.value)}
                            placeholder="0,00"
                          />
                        </div>
                        <div className="mb-3">
                          <label>Observaciones de la Nota de Débito:</label>
                          <textarea
                            className="form-control"
                            rows="3"
                            value={dataEditarPago.ObservacionesNDD || ""}
                            onChange={(e) => setDataEditarPago({...dataEditarPago, ObservacionesNDD: e.target.value})}
                          />
                        </div>
                      </div>
                    ) : (
                      <div>
                        <h5>Tipo de pago no reconocido</h5>
                        <p>No se puede editar este tipo de pago: {dataEditarPago.Tipo}</p>
                      </div>
                    )}
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="outline-secondary" onClick={() => cerrarModalEditarPago()}>
                  Cancelar
                </Button>
                <Button variant="success" onClick={() => guardarCambiosPago()}>
                  Guardar Cambios
                </Button>
              </Modal.Footer>
            </Modal>
            <Modal
              show={showPregunta}
              fullscreen={true}
              onHide={() => setShowPregunta(false)}
            >
              <Modal.Header>
                <Modal.Title>{tituloModalPregunta}</Modal.Title>
                <Button
                  variant="outline-danger"
                  onClick={() => cerrarModalPregunta()}
                >
                  X
                </Button>
              </Modal.Header>
              <Modal.Body>Desea cerrar la caja?</Modal.Body>
              <Modal.Footer>
                <Button
                  variant="outline-danger"
                  onClick={() => cerrarModalCierraCaja()}
                >
                  Cerrar Caja
                </Button>
                <Button
                  variant="outline-success"
                  onClick={() => cerrarModalPregunta()}
                >
                  Salir
                </Button>
              </Modal.Footer>
            </Modal>
            <Modal
              show={showInformeCaja}
              fullscreen={true}
              onHide={() => setShowInformeCaja(false)}
            >
              <Modal.Header>
                <Modal.Title>
                  {tituloModalInformeCaja + " N°" + informeCaja[0]}
                </Modal.Title>
                <Button
                  variant="outline-danger"
                  onClick={() => cerrarModalInformeCaja()}
                >
                  X
                </Button>
              </Modal.Header>
              <Modal.Body>
                {" "}
                <Row className="d-flex justify-content-center">
                  <h4>Datos de la caja</h4>
                </Row>
                <Row className="d-flex justify-content-center">
                  <ul>
                    <li>
                      {" "}
                      Fecha de Cierre: <b>${informeCaja[9]}</b>
                    </li>
                    <li>
                      {" "}
                      Monto Efectivo: <b>${informeCaja[6]}</b>
                    </li>
                    <li>
                      {" "}
                      Monto Transferencias: <b>${informeCaja[5]}</b>
                    </li>
                    <li>
                      {" "}
                      Monto Cheques: <b>${informeCaja[3]}</b>
                    </li>
                    <li>
                      {" "}
                      Monto Tarjetas: <b>${informeCaja[4]}</b>
                    </li>
                    <li>
                      {" "}
                      Monto Total: <b>${informeCaja[8]}</b>
                    </li>
                    <li>
                      Observación: <b> {informeCaja[7]}</b>
                    </li>
                  </ul>
                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1-content"
                      id="panel1-header"
                      style={{ backgroundColor: "#f5be87" }}
                    >
                      <Typography
                        sx={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <b>Pagos de la caja</b>
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails style={{ padding: 0 }}>
                      <MUIDataTable
                        ref={containerRef}
                        title={"Pagos caja"}
                        data={historialPagosCaja}
                        columns={columnsPagosHistorialCaja}
                        options={optionsPagosCajaActual}
                        id="tablaPagosCaja"
                      ></MUIDataTable>
                    </AccordionDetails>
                  </Accordion>
                  <Col>
                    <Row
                      className="d-flex justify-content-center align-items-center "
                      style={{ padding: 10 }}
                    >
                      <Button
                        variant="info"
                        onClick={() => exportarExcel()}
                        style={{ margin: 10 }}
                      >
                        Exportar a Excel
                      </Button>
                      <Button variant="info" onClick={() => exportarPDF()}>
                        Exportar a PDF
                      </Button>
                    </Row>
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="outline-success"
                  onClick={() => cerrarModalInformeCaja()}
                >
                  Salir
                </Button>
              </Modal.Footer>
            </Modal>
            <h3>Cobros</h3>
            {content !== undefined && content !== "No token provided!" ? (
              <div>
                <Modal
                  show={show}
                  fullscreen={true}
                  onHide={() => setShow(false)}
                >
                  <Modal.Header>
                    <Modal.Title>Empleado: {dataElegido[1]}</Modal.Title>
                    <Button
                      variant="outline-danger"
                      onClick={() => cerrarModal()}
                    >
                      X
                    </Button>
                  </Modal.Header>
                  <Modal.Body style={{ borderColor: "red", borderWidth: 10 }}>
                    <Tabs
                      defaultActiveKey="actual"
                      id="uncontrolled-tab-example"
                      className="mb-3"
                      onSelect={(k) => console.log("K:" + k)}
                      style={{ borderColor: "#f9f2ed" }}
                    >
                      <Tab eventKey="actual" title="Actual">
                        <Col>
                          <Row className="d-flex justify-content-center">
                            <h4>Caja Actual</h4>
                          </Row>
                          <Row className="d-flex justify-content-center">
                            <ul>
                              <li>
                                Monto Efectivo:{" "}
                                {cajaActual.montos !== undefined ? (
                                  <b>
                                    {" $" + cajaActual.montos.montoEfectivo}
                                  </b>
                                ) : (
                                  <b>$0</b>
                                )}
                              </li>
                              <li>
                                Monto Transferencias:{" "}
                                {cajaActual.montos !== undefined ? (
                                  <b>
                                    {" $" +
                                      cajaActual.montos.montoTransferencia}
                                  </b>
                                ) : (
                                  <b>$0</b>
                                )}
                              </li>
                              <li>
                                Monto Cheques:{" "}
                                {cajaActual.montos !== undefined ? (
                                  <b>{" $" + cajaActual.montos.montoCheque}</b>
                                ) : (
                                  <b>$0</b>
                                )}
                              </li>
                              <li>
                                Monto Tarjetas:{" "}
                                {cajaActual.montos !== undefined ? (
                                  <b>{" $" + cajaActual.montos.montoTarjeta}</b>
                                ) : (
                                  <b>$0</b>
                                )}
                              </li>
                              <li>
                                Monto Total:{" "}
                                {cajaActual.montos !== undefined ? (
                                  <b>{" $" + cajaActual.montos.montoTotal}</b>
                                ) : (
                                  <b>$0</b>
                                )}
                              </li>
                            </ul>
                          </Row>
                          <Row className="d-flex justify-content-center">
                            <Accordion>
                              <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1-content"
                                id="panel1-header"
                                style={{ backgroundColor: "#f5be87" }}
                              >
                                <Typography
                                  sx={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                >
                                  <b>Pagos</b>
                                </Typography>
                              </AccordionSummary>
                              <AccordionDetails style={{ padding: 0 }}>
                                <MUIDataTable
                                  ref={containerRef}
                                  title={"Pagos caja actual"}
                                  data={cajaActual.pagos}
                                  columns={columnsPagosCajaActual}
                                  options={optionsPagosCajaActual}
                                  id="tablaPagosCajaActual"
                                ></MUIDataTable>
                              </AccordionDetails>
                            </Accordion>
                          </Row>
                          <Row
                            className="d-flex justify-content-center"
                            style={{ paddingTop: 10 }}
                          >
                            <textarea
                              id="observacion"
                              placeholder="Observación"
                              rows="5"
                              cols="27"
                            />
                          </Row>

                          <Row
                            className="d-flex justify-content-center"
                            style={{ padding: 10, gap: 10 }}
                          >
                            <Button
                              variant="danger"
                              onClick={() => setShowPregunta(true)}
                            >
                              Cerrar Caja
                            </Button>
                            <Button
                              variant="info"
                              onClick={() => exportarExcelCajaAbierta()}
                            >
                              Exportar Caja Abierta
                            </Button>
                          </Row>
                        </Col>
                      </Tab>

                      <Tab eventKey="historicoCajas" title="Historico Cajas">
                        <MUIDataTable
                          ref={containerRef}
                          title={"Historial de Cajas"}
                          data={historialDeCajas}
                          columns={columnsHistorialDeCajas}
                          options={optionsHistorialDeCajas}
                          id="tablaHistorialDeCajas"
                        ></MUIDataTable>
                      </Tab>
                    </Tabs>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="outline-success"
                      onClick={() => cerrarModal()}
                    >
                      Salir
                    </Button>
                  </Modal.Footer>
                </Modal>
                <Row>
                  <Col>
                    <ListGroup
                      horizontal={"md"}
                      style={{
                        backgroundColor: "#F9F2ED",
                        borderStyle: "hidden",
                        marginBottom: 10,
                      }}
                    >
                      <ListGroup.Item
                        style={{
                          backgroundColor: "#F9F2ED",
                          borderStyle: "hidden",
                        }}
                      >
                        <ListGroup.Item
                          action
                          onClick={chequesClicked}
                          style={{ backgroundColor: "#f5be87" }}
                        >
                          <b>Cheques</b>
                        </ListGroup.Item>
                        <ListGroup.Item
                          onClick={historicoCajasClicked}
                          style={{ backgroundColor: "#f5be87", marginTop: 4 }}
                        >
                          <b>Historico Cajas</b>
                        </ListGroup.Item>
                      </ListGroup.Item>
                    </ListGroup>
                    <MUIDataTable
                      ref={containerRef}
                      title={"Clientes"}
                      data={empleados}
                      columns={columnsEmpleados}
                      options={options}
                      id="tablaEmpleados"
                    ></MUIDataTable>
                  </Col>
                </Row>
              </div>
            ) : null}
          </div>
        )}
      </Container>
    );
  } else {
    return (
      <div className="container">
        <header className="jumbotron">
          <h3>{content}</h3>
        </header>
      </div>
    );
  }
};
export default Cobros;
